import { render, staticRenderFns } from "./ServiceIntro.vue?vue&type=template&id=2c1efeaa&"
import script from "./ServiceIntro.vue?vue&type=script&lang=js&"
export * from "./ServiceIntro.vue?vue&type=script&lang=js&"
import style0 from "./service.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
